import React from 'react'
import { useTheme } from '../Context/ThemeContext';

function TechnologyItem({ name }) {

    const { primaryColor, secondaryColor } = useTheme();

    return (
        <li className={`flex opacity-90 w-1/2 my-2 text-sm ${secondaryColor} leading-relaxed before:content-["▹"] before:block before:mr-2 before:${primaryColor} before:font-extrabold`}>
            {name}
        </li>
    )
}

export default TechnologyItem